import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { PureAbility } from '@casl/ability';
import { first, intersection, isEmpty, get } from 'lodash';
import {
  ROLE_PERMISSIONS,
  PERMISSIONS,
  ORGANIZATION_PERMISSIONS,
  PRVOLT_ORGANIZATION_PERMISSIONS,
  PERMISSIONS_ACTIONS,
} from 'constants/misc';
import { isPRVoltOrganization } from 'utils/organization';


export const hasUserGroup = (userGroups, permissions) => !isEmpty(intersection(userGroups, permissions));

export const ability = new PureAbility();

export const updateAbility = (abilityObj, user) => {
  let newPerms = ROLE_PERMISSIONS[first(user.user_groups)];
  if (user.permissions.includes(PERMISSIONS.CAN_SEE_INBOX)) {
    newPerms = [...newPerms, { action: 'see', subject: 'Inbox' }];
  }
  const permissions = user.permissions.filter(permission => (
    PERMISSIONS_ACTIONS[permission]
  )).map(per => PERMISSIONS_ACTIONS[per]);
  newPerms = [...newPerms, ...permissions];
  if (user.organizations.some(obj => isPRVoltOrganization(obj.id))) {
    newPerms = [...newPerms, ...get(PRVOLT_ORGANIZATION_PERMISSIONS, first(user.user_groups), [])];
  }
  abilityObj.update(newPerms);
};

export const updateAbilityWithPerm = (abilityObj, perm) => {
  abilityObj.update([...abilityObj.rules, perm]);
};

export const updateOrganizationAbility = (abilityObj, permissions) => {
  if (permissions && permissions.includes(PERMISSIONS.CAN_SEE_SUBSCRIPTIONS)) {
    updateAbilityWithPerm(abilityObj, ORGANIZATION_PERMISSIONS.CAN_SEE_SUBSCRIPTIONS);
  }
};

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);
